import React, {FC} from "react"
import {Frames, CardFrame} from "frames-react"

import {Card} from "@irati/ui/src/Layout"
import mainTheme from "@irati/ui/src/global/theme"
import Expander from "@irati/ui/src/Expander/Expander"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {hangPromise} from "@irati/utils/promise"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import {Body} from "@irati/ui/src/Typography"
import {MutationRequestPaymentArgs, PaymentCurrencyType} from "@irati/types"
import {useRequestPaymentMutation} from "@irati/payments/hooks"
import Loading from "@irati/ui/src/Loading"

interface Props {
  amount: number
  paymentOrderId: string
  currency: PaymentCurrencyType
  returnUrl: string
  onComplete: () => void
  setLoad: (value: Promise<any>) => void
  publicKey: string
  load?: Promise<any>
}

const PayByCardHeader = () => (
  <Body>
    <FormattedMessage id="platform.payments.payByCard" />
  </Body>
)

const FramesComponent: FC<Props> = ({amount, currency, paymentOrderId, returnUrl, onComplete, load, setLoad}) => {
  const [requestPayment] = useRequestPaymentMutation()

  const handleCardTokenised = async(e) => {
    const token = e.token
    const variables: MutationRequestPaymentArgs = {
      input: {
        paymentOrderId,
        amount,
        currency,
        details: {
          token,
          resURL: returnUrl,
          rememberCard: false // drive by checkbox
        }
      }
    }
    const req = requestPayment({variables})
    setLoad(req)
    const payment = await req
    setLoad(hangPromise())

    if (payment.details.url) {
      // 3DS redirect
      window.location.href = payment.details.url
    } else {
      onComplete()
    }
  }

  return (
    <Card padding={2} bgColor={mainTheme.colors.greys.grey03}>
      <Expander showText={<PayByCardHeader />} hideText={<PayByCardHeader />} fullWidth flush>
        <Frames config={{publicKey}} cardTokenized={handleCardTokenised}>
          <Flex height="42px" marginLeft={-1.5}>
            <CardFrame />
          </Flex>

          <Button
            primary
            full
            marginTop
            load={load}
            onClick={() => {
              if (Frames.isCardValid()) {
                setLoad(hangPromise())
                Frames.submitCard()
              }
            }}>
            <FormattedMessage id="platform.payments.pay" />
            &nbsp;
            <FormattedCurrency value={amount} currency={currency} />
          </Button>
          <Loading load={load} useLoader={false} />
        </Frames>
      </Expander>
    </Card>
  )
}

export default FramesComponent
